import defaultConfig from './default';

export const configuration = defaultConfig;
